import { IComponentOptions } from "angular";
import { ContractEditController } from "./controller";

export const vsComponentName = "contractEditComponent";

export const contractEditComponentOptions: IComponentOptions = {
  controller: ContractEditController,
  template: require("!html-loader!./index.html").default,
  controllerAs: "stateController",
  bindings: {
    contract: "<",
    contractType: "<",
  },
};
